var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5505 4.22912C12.838 4.45912 12.8846 4.87865 12.6546 5.16616L6.62721 12.8964C6.39721 13.1839 5.97768 13.2305 5.69017 13.0005C5.40266 12.7705 5.35605 12.3509 5.58605 12.0634L11.6134 4.33323C11.8435 4.04572 12.263 3.99911 12.5505 4.22912Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86225 9.2353C3.1226 8.97495 3.54471 8.97495 3.80506 9.2353L6.5784 12.0086C6.83875 12.269 6.83875 12.6911 6.5784 12.9514C6.31805 13.2118 5.89594 13.2118 5.63559 12.9514L2.86225 10.1781C2.6019 9.91776 2.6019 9.49565 2.86225 9.2353Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.708b412789bb5e45b4ea4c148db2c3d0.svg";
export { ForwardRef as ReactComponent };